import React, { useState, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Button,
  CustomInput,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  putAPI_Update_Forms_Contact,
  gAPI_Internal_Property_By_Id,
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import PhoneField from '../../../Guest Messaging/reservation/PhoneField';
import {
  buildPhoneNumber,
  detectUserCountry,
  splitPhoneNumber,
} from '../../../Guest Messaging/reservation/Countrydata';

const sanitizePhoneDigits = (phoneLocalNumber = '') =>
  String(phoneLocalNumber).replace(/\D/g, '').replace(/^0+/, '');

const buildNotificationContact = (contact, defaultCountry) => {
  const phoneParts = splitPhoneNumber(contact?.phoneNumber, defaultCountry);

  return {
    ...contact,
    phoneCountry: phoneParts.country,
    phoneLocalNumber: phoneParts.localNumber,
  };
};

const hasMissingNotificationEmail = (contacts = []) =>
  (contacts || []).some((contact) => !String(contact?.email || '').trim());

function FormsContacts({
  sendMewsNotification,
  contacts,
  type,
  id,
  name,
  LoadData,
  visible,
  toggle,
  propertyId,
  languageCode,
  isSuperAdmin,
}) {
  const defaultCountry = detectUserCountry();
  const [inputFields, setInputFields] = useState(
    contacts?.length > 0
      ? contacts.map((contact) =>
          buildNotificationContact(contact, defaultCountry)
        )
      : [
          {
            type: type,
            name: '',
            email: '',
            phoneNumber: '',
            phoneCountry: defaultCountry,
            phoneLocalNumber: '',
            isBcc: false,
          },
        ]
  );
  const [notification, setNotification] = useState(
    sendMewsNotification || false
  );
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [showEmailValidationErrors, setShowEmailValidationErrors] =
    useState(false);
  const [propertyName, setPropertyName] = useState(name || '');

  useEffect(() => {
    if (name) {
      setPropertyName(name);
    } else if (propertyId && propertyId !== '-1') {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          if (res.data && res.data.propertyName) {
            setPropertyName(res.data.propertyName);
          } else if (res.data && res.data.name) {
            setPropertyName(res.data.name);
          }
        })
        .catch((err) => console.error('Error fetching property name:', err));
    }
  }, [propertyId, name]);

  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      type: type,
      name: '',
      email: '',
      phoneNumber: '',
      phoneCountry: defaultCountry,
      phoneLocalNumber: '',
      isBcc: false,
    });
    setInputFields(values);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'name') {
      values[index].name = event.target.value;
    } else if (event.target.name === 'email') {
      values[index].email = event.target.value;
    } else {
      values[index].type = event.target.value;
    }
    setInputFields(values);
  };

  const handlePhoneCountryChange = (index, country) => {
    const values = [...inputFields];
    const currentLocalNumber = sanitizePhoneDigits(
      values[index].phoneLocalNumber
    );

    values[index].phoneCountry = country;
    values[index].phoneLocalNumber = currentLocalNumber;
    values[index].phoneNumber = buildPhoneNumber(country, currentLocalNumber);
    setInputFields(values);
  };

  const handlePhoneNumberChange = (index, localNumber, metadata = {}) => {
    const values = [...inputFields];
    const detectedCountry = metadata?.detectedCountry;
    const nextCountry =
      detectedCountry || values[index].phoneCountry || defaultCountry;
    const nextLocalNumber = sanitizePhoneDigits(localNumber);

    values[index].phoneCountry = nextCountry;
    values[index].phoneLocalNumber = nextLocalNumber;
    values[index].phoneNumber = buildPhoneNumber(nextCountry, nextLocalNumber);
    setInputFields(values);
  };

  const handleCheckChange = (index, e) => {
    const values = [...inputFields];
    if (e.target.checked) {
      values[index].isBcc = true;
    } else {
      values[index].isBcc = false;
    }
    setInputFields(values);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (hasMissingNotificationEmail(inputFields)) {
      setShowEmailValidationErrors(true);
      return;
    }

    setShowEmailValidationErrors(false);

    const payloadContacts = inputFields.map((contact) => {
      const localDigits = sanitizePhoneDigits(contact.phoneLocalNumber);
      const selectedCountry = contact.phoneCountry || defaultCountry;

      return {
        ...contact,
        phoneNumber: buildPhoneNumber(selectedCountry, localDigits),
      };
    });

    const data = {
      groupId: getGroupID(),
      propertyId: propertyId,
      contacts: payloadContacts.map(
        ({ phoneCountry, phoneLocalNumber, ...restContact }) => restContact
      ),
      updater: 'admin',
      sendMewsNotification: notification,
    };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Forms_Contact}/${id}`,
      data,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        setTimeout(() => {
          LoadData(languageCode);
        }, 300);
      }
    });
  };

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggle}
        size="xl"
        modalClassName="contacts-scroll-modal"
      >
        <div className="contacts-modal-header">
          <div className="contacts-modal-heading">
            <div className="contacts-modal-icon">
              <i className="iconsminds-bell" />
            </div>
            <div>
              <h2>Get Notified on Form Submissions</h2>
              {/* {propertyName && <p>{propertyName}</p>} */}
            </div>
          </div>
          <button
            type="button"
            className="contacts-modal-close"
            onClick={toggle}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <ModalBody className="contacts-modal-body">
          <div className="contacts-top-actions">
            <Button
              onClick={handleAddFields}
              color="primary"
              size="xs"
              className="contacts-add-button"
            >
              + Add Contact
            </Button>
          </div>

          <div className="contacts-rows-scroll">
            <div
              className="contacts-table-header-row contacts-table-grid"
              style={{ gridTemplateColumns: '3fr 4fr 1fr 3.5fr 1.2fr' }}
            >
              <div className="contacts-table-cell">Name</div>
              <div className="contacts-table-cell">
                Notification Email <span style={{ color: 'red' }}> *</span>
              </div>
              <div className="contacts-table-cell contacts-table-cell--center">
                BCC
              </div>
              <div className="contacts-table-cell">
                Phone Number (for SMS Notification)
              </div>
              <div className="contacts-table-cell contacts-table-cell--center">
                Remove
              </div>
            </div>

            {inputFields != null &&
              inputFields.map((contact, index) => (
                <div
                  key={index}
                  className="contacts-table-row contacts-table-grid"
                  style={{ gridTemplateColumns: '3fr 4fr 1fr 3.5fr 1.2fr' }}
                >
                  <div className="contacts-table-cell">
                    <Input
                      className="contacts-cell-input"
                      type="text"
                      name="name"
                      value={contact.name}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </div>
                  <div className="contacts-table-cell contacts-table-cell--with-validation">
                    <Input
                      className={`contacts-cell-input ${
                        showEmailValidationErrors &&
                        !String(contact?.email || '').trim()
                          ? 'contacts-cell-input--error'
                          : ''
                      }`}
                      type="email"
                      name="email"
                      min={1}
                      value={contact.email}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                    {showEmailValidationErrors &&
                      !String(contact?.email || '').trim() && (
                        <div className="contacts-field-error-text">
                          Required
                        </div>
                      )}
                  </div>
                  <div className="contacts-table-cell contacts-table-cell--center">
                    <CustomInput
                      type="checkbox"
                      className="contacts-bcc-checkbox"
                      id={`bcc-${index}`}
                      checked={contact.isBcc}
                      name="isBcc"
                      onChange={(e) => handleCheckChange(index, e)}
                    />
                  </div>
                  <div className="contacts-table-cell">
                    <PhoneField
                      id={`notification-phone-${index}`}
                      label="Phone Number"
                      showLabel={false}
                      showValidation={false}
                      useBaseInputShell={true}
                      baseInputClassName="contacts-cell-input"
                      countryWidth={108}
                      country={contact.phoneCountry || defaultCountry}
                      localNumber={contact.phoneLocalNumber || ''}
                      disabled={false}
                      onCountryChange={(country) =>
                        handlePhoneCountryChange(index, country)
                      }
                      onNumberChange={(localNumber, metadata) =>
                        handlePhoneNumberChange(index, localNumber, metadata)
                      }
                    />
                  </div>
                  <div className="contacts-table-cell contacts-table-cell--center">
                    <Button
                      onClick={() => handleRemoveFields(index)}
                      color="secondary"
                      size="xs"
                      outline
                      className="contacts-remove-button"
                    >
                      -
                    </Button>
                  </div>
                </div>
              ))}
          </div>

          {isSuperAdmin && isSuperAdmin === true && (
            <div className="mt-3">
              <CustomInput
                type="checkbox"
                id="agree"
                value={notification}
                label="Send Notifications to Mews"
                checked={notification}
                onChange={(e) => {
                  setNotification(!notification);
                }}
              />
            </div>
          )}
        </ModalBody>
        <ModalFooter className="contacts-modal-footer">
          <Button color="primary" onClick={handleSubmit}>
            Save Notifications
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      />
    </Fragment>
  );
}

const mapStateToProps = ({ usersListApp }) => {
  const { isSuperAdmin } = usersListApp;
  return {
    isSuperAdmin,
  };
};

export default connect(mapStateToProps, {})(FormsContacts);
